<div class="hub-content-panel" >
  <ul class="nav">
    <li class="nav-item" [ngClass]="{'active': isTeamVisible}" (click)="activateTeam($event)">
      <a class="nav-link" href="#">
        <i class="icon-users"></i>
        <span>Team</span>
      </a>
    </li>
    <li class="nav-item" [ngClass]="{'active': !isTeamVisible}" (click)="activatePartners($event)">
      <a class="nav-link" href="#">
        <i class="icon-collaboration"></i>
        <span>Partners</span>
      </a>
    </li>
  </ul>

  @if (isTeamVisible) {
    <app-team-panel></app-team-panel>
  }
  @if (!isTeamVisible) {
    <app-partners-panel></app-partners-panel>
  }
</div>
